import { Component } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { CacheService } from "../../shared/services/cache.service";
import { DataService } from "../../shared/services/data.service";
import { Row, Col } from "react-bootstrap";
import { connect } from "react-redux";
import "./powerbi-report.scss";
import { SpinnerService } from "../../shared/services/spinner.service";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import { NotifierService } from "../../shared/services/notifier.service";
import { AuthenticateService } from "../../security/login/authenticate.service";
export interface PowerBIReportProps {
  id: number;
  config: any;
  title: any;
}
interface PowerBIReportState {
  initialized: boolean;
  reportConfig: any;
  title?: string;
  id?: number;
  report?: any;
  rendered?: boolean;
  resetReport?: boolean;
  embedURL2?: string;
}

export default class PowerBIReportComponent extends Component<
  PowerBIReportProps,
  PowerBIReportState
> {
  constructor(props: PowerBIReportProps) {
    super(props);
    this.state = {
      title: "Power BI Report",
      id: undefined,
      reportConfig: undefined,
      initialized: false,
      embedURL2: undefined,
    };
  }

  componentDidMount() {
    this.componentDidUpdate();
  }

  componentDidUpdate() {
    setTimeout(async () => {
      const id = this.state.id;
      if (id !== undefined && id !== null && id === this.props.id) {
        if (this.state.rendered) {
          SpinnerService.hide();
        }
        return;
      }
      SpinnerService.show();

      this.setState({
        id: this.props.id,
        initialized: false,
        reportConfig: null,
      });

      const config = await this.getEmbedConfiguration();

      if (config === null) {
        SpinnerService.hide();
      }

      if (config && config.embedUrl) {
        this.setState({ embedURL2: config.embedUrl });
        config.embedUrl = null;
        SpinnerService.hide();
      }

      this.setState({
        initialized: true,
        reportConfig: config,
      });
    });
  }

  async getReportConfiguration(reportId: number) {
    if (!reportId) {
      return null;
    }

    let report: any = CacheService.getFromSession("report", reportId);

    if (report && report.data) {
      report = report.data;
    }
    if (
      report &&
      (!report.pbiTokenExpiry ||
        new Date(report.pbiTokenExpiry).getTime() < new Date().getTime())
    ) {
      report = null;
    }
    if (this.state.resetReport) {
      report = null;
    }
    if (!report) {
      let reports;
      try {
        reports = await DataService.get(`reports/${reportId}/token`);
      } catch (e) {
        console.error(e);
        reports = null;
      }
      if (reports && Array.isArray(reports)) {
        report = reports && reports.length > 0 ? reports[0] : null;
      } else {
        report = reports;
      }

      if (!report || report.errorMessage) {
        console.error("Error in report token generation", report);
        NotifierService.error(
          "Unable to render report. Please contact administrator view report."
        );
        return undefined;
      }

      if (report && report.data) {
        report = report.data;
      }

      if (report && report.pbiAccessToken) {
        CacheService.putIntoSession("report", reportId, report);
      }
    }

    return report;
  }

  async getEmbedConfiguration() {
    const reportConfig = await this.getReportConfiguration(this.props.id);
    if (!reportConfig) {
      return null;
    }

    const defaults: any = {
      type: "report",
      tokenType: 1,
      settings: {
        background: 1,
        panes: {
          bookmarks: {
            visible: false,
          },
          filters: {
            visible: false,
          },
          pageNavigation: {
            visible: false,
          },
        },
      },
    };

    const config = this.props.config || {};

    Object.keys(defaults).forEach((key) => {
      if (config[key] === undefined) {
        config[key] = defaults[key];
      }
    });

    config.accessToken = config.accessToken || reportConfig.pbiAccessToken;
    config.embedUrl = config.embedUrl || reportConfig.pbIembedURL;
    config.id = config.id || reportConfig.pbIreportId;

    return config;
  }

  csvArrayToJSON(data: any[]) {
    const header = data[0];
    const records: any[] = [];
    data.forEach((row, index) => {
      if (index === 0) {
        return;
      }

      const record: any = {};
      header.forEach((key: any, keyIndex: any) => {
        record[key] = row[keyIndex];
      });

      records.push(record);
    });

    return records;
  }

  private csvToArray(text: string) {
    let p = "";
    let row = [""];
    const ret = [row];
    let i = 0;
    let r = 0;
    let s = !0;
    let l;
    for (l of text) {
      if ('"' === l) {
        if (s && l === p) {
          row[i] += l;
        }
        s = !s;
      } else if ("," === l && s) {
        l = row[++i] = "";
      } else if ("\n" === l && s) {
        if ("\r" === p) {
          row[i] = row[i].slice(0, -1);
        }
        row = ret[++r] = [(l = "")];
        i = 0;
      } else {
        row[i] += l;
      }
      p = l;
    }
    return ret;
  }

  exportToCSV(csvData: any, fileName: string) {
    const ws = XLSX.utils.json_to_sheet(csvData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    FileSaver.saveAs(data, fileName + ".xlsx");
  }

  download() {
    if (this.state.report) {
      this.state.report.getPages().then((pages: any) => {
        pages[0].getVisuals().then(async (visuals: any) => {
          const visual = visuals[0];
          const data = await visual.exportData(1); //0 - Summarized, 1 - underlying
          const reportData = this.csvArrayToJSON(this.csvToArray(data.data));
          this.exportToCSV(reportData, "report" + new Date().getTime());
        });
      });
    }
  }

  render() {
    const rendered = () => {
      const wrapper: any = document.getElementById("report-wrapper") || {};
      if (wrapper.style) {
        wrapper.style.visibility = "";
      }
      this.setState({
        rendered: true,
        resetReport: false,
      });
      SpinnerService.hide();
    };

    const error = (exception: any) => {
      console.error(exception);
      if (exception.detail.message === "TokenExpired") {
        this.setState({
          resetReport: true,
          id: undefined,
        });
        //NotifierService.info(`Please wait. We are resetting your token.`)
      } else {
        SpinnerService.hide();
        console.warn(
          `Error occurred while rendering - Message: ${exception.detail.message}. Detailed message: ${exception.detail.detailedMessage}`
        );
      }
    };

    const initialized = this.state.initialized;
    if (!initialized) {
      return <div>&nbsp;</div>;
    }

    const config = this.state.reportConfig;
    if (!config) {
      SpinnerService.hide();
      return <div>Unable to render report.</div>;
    }

    let reporttype = 2;
    const divStyle = {
      width: "100%",
      height: "100%",
    };

    const embedURL = this.state.embedURL2;
    if (embedURL) {
      SpinnerService.hide();
      return (
        <div className="report-container">
          <Row id="report-wrapper" style={{ visibility: "visible" }}>
            <Col>
              <div className="cover-workspace">
                <iframe
                  title="reportReplace with id"
                  src={embedURL}
                  style={divStyle}
                ></iframe>
              </div>
            </Col>
          </Row>
        </div>
      );
    }

    return (
      <div className="report-container">
        <Row id="report-wrapper" style={{ visibility: "hidden" }}>
          <Col>
            <PowerBIEmbed
              embedConfig={config}
              cssClassName="cover-workspace"
              eventHandlers={
                new Map([
                  ["rendered", rendered],
                  ["error", error],
                ])
              }
              getEmbeddedComponent={(embeddedReport) => {
                this.setState({
                  report: embeddedReport,
                });
              }}
            />
          </Col>
        </Row>
      </div>
    );
  }

  static properties = (state: any) => {
    return {
      reportConfig: undefined,
    };
  };

  static dispatchers = (dispatch: any) => {
    return {};
  };
}

export const PowerBIReport = connect(
  PowerBIReportComponent.properties,
  PowerBIReportComponent.dispatchers
)(PowerBIReportComponent);
